import { render } from "./DichVu.vue?vue&type=template&id=cd404354"
import script from "./DichVu.vue?vue&type=script&lang=js"
export * from "./DichVu.vue?vue&type=script&lang=js"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__